var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.displayNewDasboard)?_c('dashboard-v2'):_vm._e(),(_vm.displayNewDasboard === false)?_c('dashboard-v1'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }